import React from 'react';
import {Box, Link, Typography, IconButton, Divider, useTheme, useMediaQuery} from '@mui/material';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import {FaTiktok} from 'react-icons/fa';
import {defaultColors} from "./ColorSchema";

const navLinks = [
    {label: 'Kontakt', href: 'https://app.smart-physique.at/support'},
    {label: 'AGB & Widerrufsrecht', href: 'https://app.smart-physique.at/agb'},
    {label: 'Datenschutz', href: 'https://app.smart-physique.at/privacy-policy'},
    {label: 'Mail', href: 'mailto:info@smart-physique.at '},
];


function Footer(props) {
    const year = new Date().getFullYear();
    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down('md'))

    var openLink = (deeplink, fallback) => {
        const timeout = setTimeout(() => {
            window.location.href = fallback;
        }, 1500);

        window.location.href = deeplink;

        window.addEventListener('blur', () => clearTimeout(timeout));
    }


    return (
        <Box component="footer" sx={{
            bgcolor: '#E3E8FF',
            padding: {md: "34px", xs: " 32px 12px 32px 12px"}
        }}>
            <Box
                sx={{
                    maxWidth: '1200px',
                    mx: 'auto',
                    display: 'flex',
                    flexWrap: 'wrap',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                }}
            >
                {/* Copyright */}


                {/* Navigation Links */}
                {
                    isMobile ? (
                        <>

                            <Box sx={{display: 'flex', alignItems: 'center', flexWrap: 'wrap'}}>
                                {navLinks.map((link, idx) => (
                                    <React.Fragment key={link.href}>
                                        <Link href={link.href} underline="hover" sx={{
                                            fontSize: "12px",
                                            lineHeight: "16px"
                                        }}>
                                            {link.label}
                                        </Link>
                                        {idx < navLinks.length - 1 && (
                                            <Divider
                                                orientation="vertical"
                                                flexItem
                                                sx={{mx: 1, bgcolor: 'rgba(0,0,0,0.2)', height: 16}}
                                            />
                                        )}
                                    </React.Fragment>
                                ))}
                            </Box>
                            <Typography sx={{
                                fontSize: "12px",
                                lineHeight: "16px"
                            }} color="textPrimary">
                                ©{year} Smart Physique Coaching
                            </Typography>
                            <Box>
                                <IconButton href="https://www.facebook.com/smartphysique" aria-label="Facebook">
                                    <FacebookIcon size="14px"/>
                                </IconButton>
                                <IconButton href="https://www.instagram.com/smart.physique/" aria-label="Instagram">
                                    <InstagramIcon size="14px"/>
                                </IconButton>
                                <IconButton href="https://www.tiktok.com/@smart_physique" aria-label="TikTok" sx={{
                                    height: "32px",
                                    width: "32px",

                                }}>
                                    <FaTiktok size="16px"/>
                                </IconButton>
                            </Box>

                            {/* Social Icons */}
                        </>
                    ) : (
                        <>
                            <Typography variant="body2" color="textPrimary">
                                ©{year} Smart Physique Coaching
                            </Typography>
                            <Box sx={{display: 'flex', alignItems: 'center', flexWrap: 'wrap'}}>
                                {navLinks.map((link, idx) => (
                                    <React.Fragment key={link.href}>
                                        <Link href={link.href} underline="hover" sx={{mx: 1, color: 'primary.main'}}>
                                            {link.label}
                                        </Link>
                                        {idx < navLinks.length - 1 && (
                                            <Divider
                                                orientation="vertical"
                                                flexItem
                                                sx={{mx: 1, bgcolor: 'rgba(0,0,0,0.2)', height: 16}}
                                            />
                                        )}
                                    </React.Fragment>
                                ))}
                            </Box>

                            <Box>
                                <IconButton
                                    component="a"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    href="https://www.facebook.com/smartphysique"
                                    aria-label="Facebook">
                                    <FacebookIcon size="16px"/>
                                </IconButton>
                                <IconButton
                                    component="a"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    href="https://www.instagram.com/smart.physique/"
                                    aria-label="Instagram">
                                    <InstagramIcon size="16px"/>
                                </IconButton>
                                <IconButton
                                    component="a"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    href="https://www.tiktok.com/@smart_physique"
                                    aria-label="TikTok" sx={{
                                    height: "40px",
                                    width: "40px",
                                }}>
                                    <FaTiktok size="16px"/>
                                </IconButton>
                            </Box>
                        </>
                    )
                }

            </Box>

            {/* Bottom Divider */}
            <Divider sx={{marginTop: "24px", bgcolor: defaultColors.primary}}/>
        </Box>
    );
}

export default Footer;
